var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-lg-12" }, [
      _c("div", { staticClass: "card card-primary" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "card-body" }, [
          _c("h2", [_vm._v("Status: " + _vm._s(_vm.projectScheduleStatus))]),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _vm._m(2),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-footer" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-6" }, [
              _c(
                "a",
                {
                  staticClass: "btn btn-block sgp-btn-default",
                  attrs: {
                    type: "button",
                    target: "_blank",
                    href: _vm.projectScheduleLink,
                  },
                },
                [
                  _vm._v(
                    "\n                            View Schedule\n                        "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-block sgp-btn-default",
                  on: { click: _vm.onSubmit },
                },
                [
                  _vm._v(
                    "\n                            Submit Schedule\n                        "
                  ),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h3", { staticClass: "card-title" }, [_vm._v("Schedule Information")]),
      _vm._v(" "),
      _c("div", { staticClass: "card-tools" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-tool",
            attrs: { type: "button", "data-card-widget": "collapse" },
          },
          [_c("i", { staticClass: "fas fa-minus" })]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        "Use the schedule template below to fill in all relevant information, and use the "
      ),
      _c("b", [_vm._v("Submit Schedule")]),
      _vm._v(" button to submit it."),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v("Click the "),
      _c("b", [_vm._v("View Schedule")]),
      _vm._v(
        " button to access the Google Sheet Schedule in your browser outside of the client portal. If you leave the portal, don't forget to return to click "
      ),
      _c("b", [_vm._v("Submit Schedule")]),
      _vm._v(" button once it is ready."),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }